import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "count"]
  static values = { liked: Boolean, url: String }

  toggle() {
    const method = this.likedValue ? "DELETE" : "POST"
    const url = this.urlValue

    fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        if (data.success) {
          this.likedValue = data.liked
          this.updateUI(data.likes_count)
        }
      })
      .catch(error => {
        console.error('Error toggling like:', error)
      })
  }

  updateUI(count) {
    this.countTarget.textContent = count

    if (this.likedValue) {
      this.iconTarget.classList.remove("bi-hand-thumbs-up")
      this.iconTarget.classList.add("bi-hand-thumbs-up-fill")
      this.iconTarget.classList.add("liked")
    } else {
      this.iconTarget.classList.remove("bi-hand-thumbs-up-fill")
      this.iconTarget.classList.add("bi-hand-thumbs-up")
      this.iconTarget.classList.remove("liked")
    }
  }
}
